module.exports = __webpack_public_path__ + "media/images/icons/facebook_share_yellow-607dac71a8b06d33da12bc4cb50281c8.svg";